import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=3050463e&"
import script from "./Bills.vue?vue&type=script&lang=ts&"
export * from "./Bills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports